module.exports = __webpack_public_path__ + "media/images/stock_groups/e535-4a2cfb388ff2900c6f5f09c9efa69c5d.svg";